import { faBathtub, faBed, faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {useParams} from 'react-router-dom';
import './property-description.scss';
import React, { useEffect, useState } from 'react';
import axios from "axios";
import {SERVER_URL, PROPERTY_API_PATH, PAYMENT_PLAN_API_PATH} from "../../../../global_vars";
import { PropertyGetResponse, PropertyInfo, PropertyStatus } from "../../../shared/types/property";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import ViewMap from "../../../shared/components/view-map/view-map";
import { PaymentPlanGetResponse, PaymentPlanInfo } from "../../../shared/types/payment-plan";
import { Carousel, CarouselItem } from "react-bootstrap";

interface ExchangeRateAED {
    usd: {
        rate: number;
    }
}

interface ExchangeRateStore {
    rate: number;
    expiryTime: Date;
}

function PropertyDescription() {
    const { property_id } = useParams();
    const exchangeRatesForUSD = "https://floatrates.com/daily/aed.json";
    const exchangeRateKey = "aed_to_usd_rate";
    const maxValidHours: number = 6;

    const [aedToUSD, setAEDToUSD] = useState<number>(0);
    const [currPrice, setCurrPrice] = useState<number|null>(0);

    const [imageFocused, setImageFocused] = useState<boolean>(false);

    const [currency, setCurrency] = useState<string>("AED");

    const [state, setState] = useState<PropertyInfo>({
        id: null,
        developer_ids: [],
        payment_plan_ids: [],
        amenity_ids: [],
        amenities: [],
        property_images: [],
        name: "",
        type: "",
        description: "",
        bed: "",
        bath: "",
        min_bed: null,
        max_bed: null,
        min_bath: null,
        max_bath: null,
        area: null,
        street_address: "",
        county: "",
        state: "",
        country: "",
        zipcode: "",
        price: null,
        status: PropertyStatus.Open,
        latitude: null,
        longitude: null,
    });

    useEffect(() => {
        console.log(currPrice);
    }, [currPrice]);

    const [paymentPlan, setPaymentPlan] = useState<PaymentPlanInfo[]>([]);

    useEffect(() => {
        const id = property_id || '';
        getPropertyInfo(parseInt(id));
        setAEDToUSDRate();
    }, [property_id])


    const setPrice = (currency: string) => {
        if  (currency === "USD") {
            // why is state price null?? @praneethct
            // initial state for price is null, this is just a null check on load
            if(state.price !== null) {
                setCurrPrice(Math.round(state.price * aedToUSD));
            }
        }

        if (currency === "AED") {
            setCurrPrice(Math.round(state.price ?? 0));
        }
    }

    const handleCurrencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
        setCurrency(value);
        setPrice(value);

    }


    const getPropertyInfo = (propertyID: number) => {
        axios.get<PropertyGetResponse>(`${SERVER_URL}${PROPERTY_API_PATH}/${propertyID}`).then((resp) => {
            return resp.data;
        }).then((data) => {
            var propertyInfo = data.data;
            setState({
                ...propertyInfo
            })
            setCurrPrice(data.data.price);
            return Promise.all(
                    propertyInfo.payment_plan_ids.map((payment_plan_id: number) =>
                    axios.get<PaymentPlanGetResponse>(`${SERVER_URL}${PAYMENT_PLAN_API_PATH}/${payment_plan_id}`
                    ).then(
                        resp => resp.data
                    ).then(data => data.data)
                    ));

        }).then((paymentPlanInfo) => {
            setPaymentPlan(paymentPlanInfo)
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const handleImageFocus = () => {
        setImageFocused(!imageFocused);
    }


    const setAEDToUSDRate = () => {

        let exchangeRate = localStorage.getItem(exchangeRateKey);
        if (exchangeRate !== null && exchangeRate !== "") {
            let exchangeRateStore: ExchangeRateStore = JSON.parse(exchangeRate);
            let currDate = new Date();
            if(exchangeRateStore.expiryTime > currDate) {
                setAEDToUSD(exchangeRateStore.rate);
            }
        }

        axios.get<ExchangeRateAED>(exchangeRatesForUSD).then((resp) => {
            console.log("currency rate: ", resp.data);
            setAEDToUSD(resp.data.usd.rate);
            let currDate = new Date();
            currDate.setHours(currDate.getHours() + maxValidHours);
            let newStoreState: ExchangeRateStore = {
                rate: resp.data.usd.rate,
                expiryTime: currDate,
            };
            localStorage.setItem(exchangeRateKey, JSON.stringify(newStoreState));
        }).catch((error) => {
            console.log("error while requesting for exchange rates: ", error);
        });

    }

    return(
        <div className="property-description">

            <div className="carousel-slider">

                <Carousel controls={imageFocused} indicators={imageFocused} onMouseEnter={handleImageFocus}
                          onMouseLeave={handleImageFocus}>
                    {
                        state.property_images.map((image, index) => (
                            <CarouselItem>
                                <img src={image} className={"img-fluid"} alt={image + index}/>
                            </CarouselItem>
                        ))
                    }
                </Carousel>

            </div>

            <div className="property-details">

                <div className="property-header">
                    <div className="property-summary">
                        {/*<h4 className="property-status">*/}
                        {/*<span*/}
                        {/*    className="badge rounded-0 text-bg-dark">{state.status.replace("_", " ").toUpperCase()}</span>*/}
                        {/*</h4>*/}
                        {/* need to check the below change with @praneethct */}
                        <h1 className="property-name">{state.name}</h1>
                        <p className="property-address">{state.street_address}, {state.county}, {state.state}, {state.country}</p>
                    </div>
                    <h2 className="property-price">
                        {currency === "USD" ? currPrice?.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD'
                        }) : currPrice?.toLocaleString('en-AE', {
                            style: 'currency',
                            currency: 'AED'
                        })}
                        <div className="btn-group currency-picker" role="group">
                            <input type="radio" className="btn-check"
                                   name="currency" id="usd" value="USD"
                                   checked={currency === "USD"} onChange={handleCurrencyChange}/>
                            <label className="btn btn-outline-dark" htmlFor="usd">USD</label>

                            <input type="radio" className="btn-check"
                                   name="currency" id="aed" value="AED"
                                   checked={currency === "AED"} onChange={handleCurrencyChange}/>
                            <label className="btn btn-outline-dark" htmlFor="aed">AED</label>
                        </div>
                    </h2>
                </div>

                <hr style={{width: "60%"}}/>

                <div className="property-content-header">
                    <h2>ABOUT THE PROPERTY</h2>
                </div>

                <div className="property-content">

                    <div dangerouslySetInnerHTML={{__html: state.description}}
                         className="property-content-body"/>

                    <div className="property-features">
                        <div className="feature-item">
                            <FontAwesomeIcon className="feature-icon" icon={faBed as IconProp}/>
                            <span className="feature-text">{state.min_bed} - {state.max_bed} Beds</span>
                        </div>

                        <div className="feature-item">
                            <FontAwesomeIcon className="feature-icon" icon={faBathtub as IconProp}/>
                            <span className="feature-text">{state.min_bath} - {state.max_bath} Baths</span>
                        </div>

                        <div className="feature-item">
                            <FontAwesomeIcon icon={faExpandArrowsAlt as IconProp}
                                             style={{border: "2px solid black", borderRadius: "4px"}}/>
                            <span className="feature-text">{state.area?.toLocaleString()} SqFt</span>

                        </div>

                    </div>

                </div>

            </div>

            <div className="property-amenity" style={{backgroundImage: `url(${state.property_images[4]})`}}>
                <div className="property-amenity-overlay">
                    <h2 className="amenity-header">AMENITIES</h2>
                    <ul className="amenity-list">
                        {state.amenities.map((amenity, index) => (
                            <li key={index} className="amenity-item">
                                {amenity}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="property-payment">
                <h2 className="payment-header">Payment Plan</h2>
                <Carousel className="property-payment-plans" controls={true} indicators={true} interval={5000}>
                    {
                        paymentPlan.map((paymentPlanInfo, index) => (
                            <CarouselItem key={index} style={{height: "auto"}}>
                                <div className="property-payment-content">
                                    <h4 style={{marginLeft: '10px'}}>{paymentPlanInfo.name.toUpperCase()}</h4>
                                    <table className="payment-plan-table">
                                        <thead>
                                        <tr style={{
                                            // backgroundColor: "#001F3F",
                                            backgroundColor: "black",
                                            color: "white"
                                        }}>
                                            <th style={{
                                                padding: "15px",
                                                // border: "1px solid #ddd"
                                            }}>Stage
                                            </th>
                                            <th style={{
                                                padding: "15px",
                                                // border: "1px solid #ddd"
                                            }}>Payment
                                            </th>
                                            <th style={{
                                                padding: "15px",
                                                // border: "1px solid #ddd"
                                            }}>Percentage
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {paymentPlanInfo.plan_format.map((planFormat, index) => (
                                            <tr key={index} style={{
                                                // backgroundColor: index % 2 === 0 ? "#F8F9FA" : "#E3E6EA"
                                                backgroundColor: "#E3E6EA"
                                            }}>
                                                <td style={{
                                                    padding: "15px",
                                                    // border: "1px solid #ddd",
                                                    fontWeight: "bold"
                                                }}>{planFormat.stage}</td>
                                                <td style={{
                                                    padding: "15px",
                                                    // border: "1px solid #ddd",
                                                    fontWeight: "bold"
                                                }}>{(((currPrice || 0) * (planFormat?.percentage ?? 0)) / 100).toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: currency
                                                })}</td>
                                                <td style={{
                                                    padding: "15px",
                                                    // border: "1px solid #ddd",
                                                    fontWeight: "bold"
                                                }}>{planFormat.percentage}%
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </CarouselItem>
                        ))
                    }
                </Carousel>

                <p style={{marginLeft: '25px'}}>
                    <sup>*</sup>
                    <span style={{cursor: "pointer", fontWeight: "bold"}}
                          onClick={() => document.getElementById("footer")?.scrollIntoView({behavior: "smooth"})}>
                        Contact Us
                    </span> to get flexible payment plans exclusive to our trusted developers
                </p>

            </div>

            <div className="property-map">

                <div className="map-header">
                    <h2>LOCATION</h2>
                    <span className="text-end">
                        {state.street_address}, {state.county}, {state.state}, {state.country}
                    </span>
                </div>

                <div className="map-content">
                    <ViewMap latitude={state.latitude ?? 0} longitude={state.longitude ?? 0}/>
                </div>

            </div>

        </div>

    );

}

export default PropertyDescription;